import { render, staticRenderFns } from "./ButtonWithArrow.vue?vue&type=template&id=efacf856&scoped=true&"
import script from "./ButtonWithArrow.vue?vue&type=script&lang=js&"
export * from "./ButtonWithArrow.vue?vue&type=script&lang=js&"
import style0 from "./ButtonWithArrow.vue?vue&type=style&index=0&id=efacf856&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efacf856",
  null
  
)

export default component.exports